import React from 'react';
import styles from './Label.module.scss';

export const Label: React.FC<{
  label: React.ReactNode | string;
  className?: string;
  children?: React.ReactNode | string;
}> = (props) => {
  const { label, children, className } = props;
  return (
    <div className={styles.labelBox + ` ${className || ''}`}>
      <span className={styles.label}>{label}</span>
      <div>{children}</div>
    </div>
  );
};
